import React from "react";
import { Typography, Grid, Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import SimulationDisclaimer from "./simulation-disclaimer";
import NewSimulationButton from "./new-simulation-button";
import SimulationNameInputModal from "./simulation-name-input-modal";

const useStyles = makeStyles((theme) => ({
    title: {
        fontWeight: 500,
        color: "#2E2E38",
    },
    buttonContainer: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        [theme.breakpoints.down("xs")]: {
            justifyContent: "flex-start",
            marginTop: theme.spacing(2),
        },
    },
}));

export default function SimulationsHeader() {
    const classes = useStyles();
    return (
        <Box>
            <SimulationNameInputModal/>
            <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} sm={6}>
                    <Typography variant="h4" className={classes.title}>
                        Simulations
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={6} className={classes.buttonContainer}>
                    <NewSimulationButton />
                </Grid>
            </Grid>
            <Box>
                <SimulationDisclaimer />
            </Box>
        </Box>
    )
}
